import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useMatch, useParams } from 'react-router-dom';
import styled from 'styled-components';
import OutletWrapper from '../animations/animated-routes/animated-outlet';
import ProductSelectionBreadcrumb from '../breadcrumb/sales-flow-breadcrumb-component';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  justify-content: center;
  width: 100%;
`;

const OutletContainer = styled.div`
  width: 100%;
  margin-right: auto;
  height: calc(100vh - 188px);
  margin-top: 64px;
`;

/**
 *
 * Renders a page layout with optional elements like breadcrumb and Outlet.
 * @param {boolean} fullWidth  Whether to display full width or not
 * @returns {JSX.Element} The rendered User Management page component.
 */
const SalesFlowPageWrapper = ({ fullWidth }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation();
  const stepOne = !!useMatch('shop/sales/select-supplier');
  const stepTwo = !!useMatch('shop/sales/select-product-category');
  const stepThree = !!useMatch('shop/sales/select-product');
  const stepFour = !!useMatch('shop/sales/configuration');
  const stepFive = !!useMatch('shop/sales/main-summary/*');
  const { id: quoteId } = useParams();

  const steps = [
    {
      index: 0,
      key: 'select-supplier',
      label: 'Select Supplier',
      navigation: 'select-supplier',
    },
    {
      index: 1,
      key: 'select-product-category',
      label: 'Select Product Category',
      navigation: 'select-product-category',
    },
    {
      index: 2,
      key: 'product',
      label: 'Select Product',
      navigation: 'select-product',
    },
    {
      index: 3,
      key: 'options',
      label: 'Configure',
      navigation: 'configuration',
    },
    {
      index: 4,
      key: 'summary',
      label: 'Summary',
      navigation: `main-summary/${quoteId}/summary`,
    },
  ];

  useEffect(() => {
    if (stepOne) {
      setActiveIndex(0);
    } else if (stepTwo) {
      setActiveIndex(1);
    } else if (stepThree) {
      setActiveIndex(2);
    } else if (stepFour) {
      setActiveIndex(3);
    } else if (stepFive) {
      setActiveIndex(4);
    }
  }, [location, stepFive, stepFour, stepOne, stepThree, stepTwo]);

  return (
    <Wrapper>
      <ProductSelectionBreadcrumb
        steps={steps}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
      />
      <OutletContainer $fw={fullWidth || stepThree}>
        <OutletWrapper slide={25} slideUp={0} initial={false} />
      </OutletContainer>
    </Wrapper>
  );
};

SalesFlowPageWrapper.defaultProps = {
  fullWidth: false,
};

SalesFlowPageWrapper.propTypes = {
  fullWidth: PropTypes.bool,
};

export default SalesFlowPageWrapper;
